<template>
  <div class="email-complete">
    <base-modal>
      <p class="email-complete__text">メールアドレスの変更が完了しました。</p>
    </base-modal>
  </div>
</template>

<script>
import BaseModal from '../common/BaseModal'

export default {
  name: 'UserAccountEmailComplete',
  components: {
    BaseModal,
  },
  created () {
    // ログアウト処理
    this.$store.dispatch('LOGOUT')
  },
}
</script>

<style lang="scss" scoped>
@import '../../../../sass/commons/commonVariables.scss';

.email-complete {
  &__text {
    margin: 0 0 60px;
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/User/UserAccountEmailComplete.vue